import { useEffect, useState } from "react";
import api, { fmtCurrency } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Plus, Trash2, Building2, User } from "lucide-react";

export default function Contacts() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  const [form, setForm] = useState(empty());
  function empty() { return { name: "", type: "musteri", tax_id: "", phone: "", email: "", opening_balance: 0, currency: "TRY" }; }
  const load = () => api.get("/contacts").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/contacts", { ...form, opening_balance: parseFloat(form.opening_balance) });
      toast.success("Cari eklendi"); setOpen(false); setForm(empty()); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };
  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/contacts/${id}`); toast.success("Silindi"); load();
  };

  const filtered = rows.filter((r) => filter === "all" || r.type === filter);

  return (
    <div className="space-y-5 nf-fade-up">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest font-mono-num text-slate-500">CARİ DEFTER</div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">Müşteri & Tedarikçi</h1>
        </div>
        <div className="flex gap-2">
          <div className="flex gap-1 p-1 bg-slate-900/60 rounded-lg border border-slate-800">
            {[["all", "Tümü"], ["musteri", "Müşteri"], ["tedarikci", "Tedarikçi"]].map(([v, l]) => (
              <button key={v} data-testid={`filter-${v}`} onClick={() => setFilter(v)}
                className={`px-3 py-1.5 text-xs rounded-md font-medium ${filter === v ? "bg-cyan-500/15 text-cyan-300" : "text-slate-400 hover:text-slate-200"}`}>{l}</button>
            ))}
          </div>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="add-contact-btn" className="bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold"><Plus className="w-4 h-4 mr-1.5" /> Yeni Cari</Button></DialogTrigger>
            <DialogContent className="bg-[#121722] border-slate-800">
              <DialogHeader><DialogTitle className="font-head">Yeni Cari Hesap</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Ad / Firma</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Tür</Label>
                    <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                      <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue /></SelectTrigger>
                      <SelectContent><SelectItem value="musteri">Müşteri</SelectItem><SelectItem value="tedarikci">Tedarikçi</SelectItem></SelectContent>
                    </Select>
                  </div>
                  <div><Label>VKN/TCKN</Label><Input value={form.tax_id} onChange={(e) => setForm({ ...form, tax_id: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Telefon</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                  <div><Label>E-posta</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Döviz</Label>
                    <Select value={form.currency} onValueChange={(v) => setForm({ ...form, currency: v })}>
                      <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue /></SelectTrigger>
                      <SelectContent>{["TRY", "USD", "EUR"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                    </Select>
                  </div>
                  <div><Label>Açılış Bakiye</Label><Input type="number" value={form.opening_balance} onChange={(e) => setForm({ ...form, opening_balance: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                </div>
                <Button onClick={save} className="w-full bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold">Kaydet</Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filtered.map((c) => {
          const positive = c.balance >= 0;
          const Icon = c.type === "musteri" ? User : Building2;
          return (
            <div key={c.id} className="nf-card p-5 group">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-slate-800/70 flex items-center justify-center text-cyan-400"><Icon className="w-5 h-5" /></div>
                  <div>
                    <div className="font-head font-bold">{c.name}</div>
                    <div className="text-[10px] uppercase tracking-widest font-mono-num text-slate-500 mt-0.5">{c.type} • VKN {c.tax_id || "—"}</div>
                  </div>
                </div>
                <button onClick={() => del(c.id)} className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-rose-400 p-1 transition"><Trash2 className="w-3.5 h-3.5" /></button>
              </div>
              <div className="mt-4 pt-4 border-t border-slate-800/60">
                <div className="text-[10px] uppercase tracking-widest font-mono-num text-slate-500">{positive ? "Alacak" : "Borç"}</div>
                <div className="font-head font-extrabold text-2xl font-mono-num mt-1" style={{ color: positive ? "#10B981" : "#F43F5E" }}>
                  {fmtCurrency(Math.abs(c.balance), c.currency)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
